var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11H4.5",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.9999H14.5",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 36H20.5",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0243 19H32.6087C28.4241 19 24.735 21.7408 23.5326 25.7429L16.8997 47.8198C16.039 50.6846 16.5855 53.7869 18.3735 56.1864C20.1615 58.5859 22.9805 60 25.9758 60H60.3913C64.5759 60 68.265 57.2592 69.4674 53.2571L76.1003 31.1802C76.961 28.3155 76.4145 25.2131 74.6265 22.8136C72.8385 20.4141 70.0196 19 67.0243 19Z",
    stroke: "#00B26B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardSuccess);
export default __webpack_public_path__ + "static/media/creditCardSuccess.a802444176af404167b5ba9d91dd125f.svg";
export { ForwardRef as ReactComponent };